export const isEmail = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

// const validateDNI = (dni) => {
//     //  DNI validation
//     var numero
//     var letr
//     var letra
//     var expresion_regular_dni

//     expresion_regular_dni = /^\d{8}[a-zA-Z]$/;

//     if (expresion_regular_dni.test(form.dni) === true) {
//         numero = form.dni.substr(0, form.dni.length - 1);
//         letr = form.dni.substr(form.dni.length - 1, 1);
//         numero = numero % 23;
//         letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
//         letra = letra.substring(numero, numero + 1);
// //         if (letra !== letr.toUpperCase()) {
// //             setErrors({ ...errors, error: 'Dni erroneo, la letra del NIF no se corresponde' });
// //             return false
// //         }
// //     } else {
// //         setErrors({ ...errors, error: 'Dni erroneo, formato no válido' });
// //         return false
// //     }
// // }

// const validateSignUpForm = (form) => {
//     // //  Empty fields
//     // if (!form?.firstname | !form?.lastname | !form?.dni | !form?.email | !form?.tlf | !form?.password) {
//     //     setErrors({ ...errors, error: 'Es necesario cumplimentar todos los campos' });
//     //     return false
//     // }

//     //  Invalid email
//     if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/.test(form.email)) {
//         setErrors({ ...errors, error: 'Email no válido' })
//         return false
//     }



//     //  Tlf length
//     if (form.tlf.length < 9) {
//         setErrors({ ...errors, error: 'El número de teléfono no es válido' })
//         return false
//     }

//     //  Password length
//     if (form.password.length < 9) {
//         setErrors({ ...errors, error: 'La contraseña debe tener al menos 8 caracteres' })
//         return false
//     }

//     return true
// }

// export default {
//     validateSignUpForm,
// }